module.exports = __webpack_public_path__ + "img/smb-id-tag-silver.256.a4d7310d.png";